import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

import { ONLY_NUMBER_OR_DECIMAL_PATTERN } from '@shared-constants/pattern-constants';
import { limitDecimalDisplay } from '@shared-helpers/string-number-helpers';
import { ISupportedSkfTypes } from '@shared-interfaces/api';

import { ISelectOptions } from '../../scripts/productionText';
import { DatahubService } from '../../services/datahub.service';

@Component({
  selector: 'grid-switch',
  templateUrl: './grid-switch.component.html',
  standalone: false,
})
export class GridSwitchComponent {
  @Input() public type?: ISupportedSkfTypes;
  @Input() public value = new FormControl<string | boolean>('', { nonNullable: true });
  @Input() public label = '';
  @Input() public options: ISelectOptions[] = [];

  public isTimesheetApproved: boolean = this.datahub.timesheet.isTimesheetApproved;

  constructor(private readonly datahub: DatahubService) {}

  public trimDecimal(event: FocusEvent): void {
    (event.target as HTMLInputElement).value = limitDecimalDisplay((event.target as HTMLInputElement).value);
    this.value.setValue((event.target as HTMLInputElement).value);
  }

  public onlyNumberOrDecimal(str: string): boolean {
    return ONLY_NUMBER_OR_DECIMAL_PATTERN.test(str);
  }
}
